import { isMobile } from '@utils/ua/is-mobile';
import SaleModal from './index';

/** 确认对话框 promise 式调用, 兼容 pc/移动端 */
export const confirm = (data: Parameters<typeof SaleModal.show>[0]) => {
  let close;
  const q: Promise<void> & { close?(): void } = new Promise<void>((res, rej) => {
    close = SaleModal.show({
      ...data,
      onCancel: rej,
      onConfirm: () => res(),
      isMobile: isMobile(),
    });
  });
  q.close = close;
  return q;
};

export default confirm;
